import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { ExtractContextReasons } from '../../helpers/context-reason-helper';
import { ContextHolder, ContextMetadata } from '../../record/entities/metadata.entity';

@Pipe({
    standalone: false,
    name: 'contextReason',
    pure: true
})
export class ContextReasonPipe implements PipeTransform {
    constructor(private readonly translateService: TranslateService) {}

    transform(record: ContextHolder, action: keyof ContextMetadata): string {
        return ExtractContextReasons(record, action, this.translateService.instant('actions.common.disabled'));
    }
}
